<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="container {{isShadowIcon ? 'shadow-icon': ''}}
{{locoIcon.clockDisplayedClass}} {{(locoIcon?.backgroundClass === 'light-blue' && locoIcon?.locoBorderClass === 'lightblue') ? 'light-blue-background' : ''}} {{(locoIcon?.backgroundClass === 'light-blue' && locoIcon?.isLocoLightBlueBorder) ? 'light-blue-multicolor':''}} {{isYardLocalScreen ? 'yard-loco-svg' : ''}} {{(isDueOutShopScreen || isStorageScreen) ? 'due-shop-storage' : ''}}">
	<div class="loco-cell noselect  p-g-12 p-md-3 {{locoIcon.locoDirectionClass}}">
		<div class="layer0 {{locoIcon.backgroundClass}}"></div>
		<!--<div class="layer1" *ngIf="isUnitIsAvailable()"></div>-->
		<div class="layer2" *ngIf="isUnitHasNextPlannedAssignment()"></div>
		<div class="service-number" *ngIf="!isShadowIcon" [ngClass]="addClass('layer3')">{{locoIcon?.firstTextBelowLocomotive}}</div>
		<div class="text-above-loco">{{loco?.textAboveLoco}}</div>
		<div class="projected-out {{locoIcon.projectedOutClass}}" *ngIf="this.isDueOutShopScreen || locoIcon.isStoredUnit">{{locoIcon?.projectedOutText}}</div>
		<!-- For non yard and local -->
		<div class="text-below-loco" *ngIf="isYardLocalScreen">{{loco?.textBelowLoco}}</div>
		<div class="layer4 {{locoIcon.questionMarkClass}}" *ngIf="locoIcon && locoIcon.isQuestionMarkDisplayed">?</div>
		<div class="layer5 {{isPTCEquippedSlug() ? 'ptc-slug': ''}} {{locoIcon.locoBorderClass}} {{locoIcon.showUpperLid ? 'no-top-lid':''}}" [ngStyle]="locoIcon.layer5Style">
			<div *ngIf="locoIcon?.showUpperLid" class="top-white-lid-complete">
				<span class="top-white-lid {{locoIcon.backgroundClass}}"></span>
				<span class="top-color-left"></span>
				<span class="top-color-right"></span>
			</div>
			<span class="ptc-equipped-slug"></span>
			<div *ngIf="isPTCEquippedWithDefect()">
				<span class="strap1"></span>
				<span class="strap2"></span>
				<span class="strap3"></span>
				<span class="strap4"></span>
				<span class="strap5"></span>
				<span class="strap6"></span>
				<span class="strap7"></span>
				<span class="strap8"></span>
			</div>
		</div>
		<div class="loco-title" *ngIf="loco">
			<span class="loco-initial {{locoIcon.textUnderLineClass}} {{locoIcon.textItalicClass}}">{{this.locoIcon?.locoInitial}}</span>
			<span class="loco-number {{locoIcon.textUnderLineClass}} {{locoIcon.textItalicClass}}">{{this.locoIcon?.locoNumber}}</span>
			<span class="shadow-text">{{shadowOverText}}</span>
		</div>
		<span class="center-dot" *ngIf="isFeatureCodeIndicatingHeavy()"></span>
		<!-- Layers 6 - 8 are PTC options and do not require markup -->

		<div *ngIf="!isRemoteControlledPlatformLocomotive()" class="layer9 {{locoIcon.locoBonnetTextClass}} {{locoIcon.locoBackgoundClass}}">{{locoIcon?.bonnetText}}</div>
		<div class="layer10">
			<div class="wheel-end {{locoIcon.backwardWheelsClass}} {{locoIcon.locoBackgoundClass}}"></div>
			<div class="wheel2 {{locoIcon.backwardWheelsClass}} {{locoIcon?.wheelFrontClass}} {{locoIcon.locoBackgoundClass}}"></div>
			<div class="wheel3 {{locoIcon.backwardWheelsClass}} {{locoIcon?.wheel3Class}} {{locoIcon.locoBackgoundClass}}"></div>
			<div class="wheel4 {{locoIcon.forwardWheelsClass}} {{locoIcon?.wheel4Class}} {{locoIcon.locoBackgoundClass}}"></div>
			<div class="wheel5 {{locoIcon.forwardWheelsClass}} {{locoIcon?.wheelEndClass}} {{locoIcon.locoBackgoundClass}}"></div>
			<div class="wheel-front {{locoIcon.forwardWheelsClass}} {{locoIcon.locoBackgoundClass}}"></div>
		</div>
		<!--<div class="layer12" *ngIf="loco && loco.rduInstalled"></div>-->
		<div class="layer13 {{locoIcon.thpClass}}">{{getThpInfo(loco)}}</div>
		<div class="layer15 {{locoIcon.antennaColorClass}}">
			<!--<div class="layer17"></div>
			<div class="layer18 {{locoIcon.antennaColorClass}}"></div>-->
		</div>
		<div class="layer16">
			{{textDisplayOverTheIcon}}
		</div>
		<div class="layer21">{{this.loco.previousAssignment? this.loco.previousAssignment : ''}}</div>
		<div class="layer22">
			<span>{{locoIcon.unitArrivedAtTerminalHour}}:{{locoIcon.unitArrivedAtTerminalMinute}}</span>
		</div>
	</div>
</div>